import { IMdlCustomDialogConfiguration, MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnSettingsComponent, COLUMN_SETTING_TOKEN } from '../component/column-settings.component';
import { ColumnSettingInfo } from '../column-settings';


@Injectable()
export class ColumnSettingsService {

    constructor(
        private readonly dialogService: MdlDialogService
    ) {
    }

    public openColumnSettingsPopup(columnSettingInfo: ColumnSettingInfo): Observable<MdlDialogReference> {
        
        const configDialog: IMdlCustomDialogConfiguration = {
            component: ColumnSettingsComponent,
            providers: [{
                provide: COLUMN_SETTING_TOKEN, useValue: columnSettingInfo
            }],
            isModal: true,
            classes: 'column-view-dialog',
            clickOutsideToClose: false,
            enterTransitionDuration: 400,
            leaveTransitionDuration: 400
        };

        return this.dialogService.showCustomDialog(configDialog);
    }
}